import Reveal from '../components/Reveal';
import { useLanguage } from '../context/LanguageContext';

function StrategyPage() {
  const { t, isArabic } = useLanguage();
  const collageClasses = ['benefit-tile-1', 'benefit-tile-2', 'benefit-tile-3', 'benefit-tile-4'];
  const groups = [
    t.strategyPage.benefits.companies,
    t.strategyPage.benefits.banks,
    t.strategyPage.benefits.clubs,
    t.strategyPage.benefits.customers,
  ];
  const strategySignals = [
    { value: '5', label: isArabic ? 'أهداف استراتيجية' : 'Strategic Goals' },
    { value: '4', label: isArabic ? 'شرائح أساسية' : 'Core Segments' },
    { value: '100%', label: isArabic ? 'تركيز على الشفافية' : 'Transparency Focus' },
    { value: '24/7', label: isArabic ? 'محرك متابعة دائم' : 'Continuous Guidance' },
  ];

  return (
    <main className="inner-page">
      <section className="strategy-hero">
        <div className="container">
          <Reveal>
            <div className="strategy-hero-card">
              <div className="strategy-hero-bg" />
              <span className="eyebrow">{t.strategyPage.eyebrow}</span>
              <h1>{t.strategyPage.title}</h1>
              <p>{t.strategyPage.subtitle}</p>
            </div>
          </Reveal>
          <div className="strategy-signals">
            {strategySignals.map((signal, i) => (
              <Reveal key={signal.label} delay={90 * i}>
                <article className="strategy-signal-card">
                  <span className="strategy-signal-value">{signal.value}</span>
                  <span className="strategy-signal-label">{signal.label}</span>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section goals strategy-goals">
        <div className="container">
          <Reveal>
            <h2 className="center-title">{t.strategyPage.goals}</h2>
          </Reveal>
          <div className="cards five">
            {t.strategyPage.items.map((item, i) => (
              <Reveal key={item.title} delay={i * 100}>
                <article className="card card-soft">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section benefits-section">
        <div className="container">
          <Reveal>
            <span className="eyebrow center">{t.strategyPage.benefitsEyebrow}</span>
            <h2 className="center-title">{t.strategyPage.benefitsTitle}</h2>
          </Reveal>
          <div className="benefits-collage">
            {groups.map((g, i) => (
              <Reveal key={g.title} delay={i * 100}>
                <article className={`benefit-tile ${collageClasses[i]}`}>
                  <div className="benefit-overlay">
                    <h3>{g.title}</h3>
                    <ul className="bullets benefit-mini-list">
                      {g.items.map((b) => (
                      <li key={b}>
                        <span className="material-symbols-outlined check">check_circle</span>
                        <span>{b}</span>
                      </li>
                      ))}
                    </ul>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
}

export default StrategyPage;
